<script setup>
import MapToolIcons from '~/terra/components/map-tool-icons.vue';
import { useTerraStore } from '~/terra/store/terra.store.js';

const $t = inject('$t');
const raster_opacity_tools = computed(() => {
  return [
    {
      tooltip: $t('Raster opacity'),
      icon: IconHawkOpacity,
      event: 'raster-opacity',
    },
  ];
});

const terra_store = useTerraStore();

function setRasterOpacity(opacity) {
  terra_store.projects_raster_opacity_map.all_projects = opacity / 100;
  terra_store.active_projects.forEach((project) => {
    terra_store.projects_raster_opacity_map[project.uid] = opacity / 100;
  });
  terra_store.set_projects_ortho({
    projects: terra_store.active_projects,
    forceUpdate: true,
  });
}

function getRasterOpacity() {
  return Math.round((terra_store.projects_raster_opacity_map.all_projects ?? 1) * 100);
}
</script>

<template>
  <HawkMenu additional_dropdown_classes="min-w-40">
    <template #trigger>
      <MapToolIcons
        style="position: relative"
        :tools="raster_opacity_tools"
        :highlight_on_hover="false"
        :horizontal_icons="true"
      />
    </template>
    <template #content>
      <div class="p-4">
        <Vueform>
          <div class="col-span-9">
            <SliderElement
              :key="getRasterOpacity()"
              name="opacity"
              :default="getRasterOpacity()"
              tooltip-position="bottom"
              :format="{ suffix: '%' }"
              @change="setRasterOpacity"
            />
          </div>
          <div class="col-span-3 text-sm mt-0.5">
            {{ getRasterOpacity() }}%
          </div>
        </Vueform>
      </div>
    </template>
  </HawkMenu>
</template>

<style scoped lang="scss">

</style>
